var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsegnaAcasa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.2 35",
    style: {
      enableBackground: "new 0 0 42.2 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_24585",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 42.2,
    height: 35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150078543116955537540000017722057746879250075_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24585-2",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000150078543116955537540000017722057746879250075_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20593",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M7.3,20l1.8,8.3c0,0.2,0,0.4,0,0.6L7.9,33 c-0.2,0.7-0.9,1.1-1.6,0.9c0,0,0,0,0,0l-0.1,0c-0.7-0.2-1-0.9-0.8-1.6l1-3.9c0.1-0.2,0.1-0.5,0-0.7l-1.4-5.1v6.4 c0,0.2,0,0.4-0.1,0.5L3,33.6c-0.3,0.7-1,0.9-1.7,0.7c-0.6-0.3-0.9-1-0.7-1.6L2,28.8c0.1-0.2,0.1-0.3,0.1-0.5l-0.4-7.6 c0-0.1,0-0.1,0-0.2l0.6-7.6c0.1-1.2,1.1-2.1,2.3-2L6,11c0.8,0,1.6,0.6,1.9,1.3l1.3,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20594",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M3.5,13.8L5,18.2c0.3,0.8,1,1.4,1.9,1.5 l4.8,0.4l0.3-1.3L8.1,18c-0.8-0.2-1.5-0.8-1.7-1.6l-0.9-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20595",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M23.8,20L22,28.3c0,0.2,0,0.4,0,0.6l1.2,4.1 c0.2,0.7,0.9,1.1,1.6,0.9c0,0,0,0,0,0l0.1,0c0.7-0.2,1-0.9,0.8-1.6l-1-3.9c-0.1-0.2-0.1-0.5,0-0.7l1.4-5.1v6.4 c0,0.2,0,0.4,0.1,0.5l1.8,4.2c0.3,0.7,1,0.9,1.7,0.7c0.6-0.3,0.9-1,0.7-1.6L29,28.8c-0.1-0.2-0.1-0.3-0.1-0.5l0.4-7.6 c0-0.1,0-0.1,0-0.2l-0.6-7.6c-0.1-1.2-1.1-2.1-2.3-2L25.1,11c-0.8,0-1.6,0.6-1.9,1.3l-0.7,1.8l-0.7,2.5l-4.6,0.7v2l2-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20596",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M27.6,13.8l-1.5,4.4c-0.3,0.8-1,1.4-1.9,1.5 l-4.8,0.4l-0.3-1.3l3.8-0.8c0.8-0.2,1.5-0.8,1.7-1.6l0.9-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20597",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M27.8,7.8c0-1.3-1-2.3-2.3-2.3 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c0,0,0,0,0,0C26.7,10.1,27.8,9.1,27.8,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20598",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M8.1,7.4c0,0.1,0,0.3,0,0.4 c0,1.3-1,2.3-2.3,2.3c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3c0.7,0,1.4,0.3,1.8,0.9l2.1,0.5L8.1,7.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8640",
    x: 9.2,
    y: 15.4,
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    width: 6.7,
    height: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20599",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M25.5,4.7V0.5h16.2v32.6H30.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20600",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M27.8,10.4V2.6h12v28.6h-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20601",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    d: "M39.2,17.5c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9C38.7,16.5,39.2,17,39.2,17.5C39.2,17.5,39.2,17.5,39.2,17.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_393",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    x1: 33.8,
    y1: 30.5,
    x2: 33.8,
    y2: 2.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_394",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    x1: 28.1,
    y1: 12,
    x2: 39.2,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_395",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinejoin: "round"
    },
    x1: 29.4,
    y1: 22.1,
    x2: 39.2,
    y2: 22.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsegnaAcasa);
export default __webpack_public_path__ + "static/media/ConsegnaAcasa.a82663d6429f5b8621960a7358ab8df7.svg";
export { ForwardRef as ReactComponent };